import { makeHTTPProvider } from 'shared/infra/providers';

import { ITEM_MAPPERS, ITEM_TYPES } from '../../core/utils';

interface ICartItem {
  id: number;
  tipo: string;
  ignorarDescontos?: boolean;
  valorTabela?: number;
  valorEcommerce?: number;
  hairColor?: unknown;
  skinColor?: unknown;
}

interface ICatalogEntry {
  id: number;
}

async function fetchCatalog(path: string): Promise<ICatalogEntry[]> {
  try {
    const entries = await makeHTTPProvider().get<ICatalogEntry[]>(path);

    return Array.isArray(entries) ? entries : [];
  } catch (error) {
    return [];
  }
}

export async function refreshCartItems(
  items: ICartItem[],
): Promise<ICartItem[]> {
  const hasPackages = items.some(item => item.tipo === ITEM_TYPES.PACOTE);
  const hasCombos = items.some(item => item.tipo === ITEM_TYPES.COMBO);

  if (!hasPackages && !hasCombos) return items;

  const [packages, combos] = await Promise.all([
    hasPackages ? fetchCatalog('/packages') : [],
    hasCombos ? fetchCatalog('/combos') : [],
  ]);

  return items.map(item => {
    if (item.tipo !== ITEM_TYPES.PACOTE && item.tipo !== ITEM_TYPES.COMBO) {
      return item;
    }

    const catalog = item.tipo === ITEM_TYPES.COMBO ? combos : packages;
    const fresh = catalog.find(entry => entry.id === item.id);

    if (!fresh) return item;

    return ITEM_MAPPERS[item.tipo]({
      ...fresh,
      hairColor: item.hairColor,
      skinColor: item.skinColor,
    });
  });
}
